import { defineMessages } from "react-intl";

const scope = "supportui.containers.AgreementValidationTable";

export default defineMessages({
  cardIssuerIdTitle: {
    id: `${scope}.cardIssuerIdTitle`,
    defaultMessage: "Card Issuer",
  },
  supplierIdTitle: {
    id: `${scope}.supplierIdTitle`,
    defaultMessage: "Supplier",
  },
  deletedTitle: {
    id: `${scope}.deletedTitle`,
    defaultMessage: "IsDeleted",
  },
  deletedStateYesTitle: {
    id: `${scope}.deletedStateYesTitle`,
    defaultMessage: "Yes",
  },
  deletedStateNoTitle: {
    id: `${scope}.deletedStateNoTitle`,
    defaultMessage: "No",
  },
});
